module.exports = __webpack_public_path__ + "img/core-bg.ddecf2f1.jpg";